import React, { useEffect, useState } from "react";
import classess from "./Spiel.module.css";
import { Box } from "@mui/material";
import { Unstable_Popup as BasePopup } from "@mui/base/Unstable_Popup";

const GR = ({ Item, GR, Errors, GRDay, FR, setSubMenu }) => {
  const [anchor, setAnchor] = React.useState(null);
  const handleClick = (event) => {
    setAnchor(anchor ? null : event.currentTarget);
  };
  const open = Boolean(anchor);
  const id = open ? "simple-popup" : undefined;
  const [Error, setError] = useState(false);
  useEffect(() => {
    if (Errors) setError(true);
  }, [Errors]);
  const Forwrds = () => {
    setSubMenu("Hinzufügen");
    localStorage.setItem("Item", JSON.stringify(Item));
  };
  return (
    <Box className={classess.GR}>
      <Box
        className={classess.GRBox}
        sx={{
          backgroundColor: Error
            ? "rgba(255, 0, 0, 0.1)"
            : "rgb(243, 242, 247, 0.6)",
          color: Error ? "color: rgb(144, 7, 7)" : "rgba(0,0,0,0.7)",
        }}
        aria-describedby={id}
      >
        {GR}
      </Box>
      <BasePopup id={id} open={open} anchor={anchor}>
        <Box className={classess.GR2}>
          <Box className={classess.GRBox2}>{FR}</Box>
        </Box>
      </BasePopup>
      <span className={classess.Karte}>
        Karte für den {GRDay} Tag <strong onClick={Forwrds}>Bearbeiten </strong>{" "}
        | <strong onClick={FR.length === 0 ? null : handleClick}>Info</strong>
      </span>
    </Box>
  );
};

export default GR;
